// extracted by mini-css-extract-plugin
export var alignRight = "styles-module--alignRight--5ada3";
export var container = "styles-module--container--0de61";
export var fullWidth = "styles-module--fullWidth--597a3";
export var hidden = "styles-module--hidden--61bb4";
export var incoming = "styles-module--incoming--40db1";
export var message = "styles-module--message--6707c";
export var messageGrow = "styles-module--messageGrow--c15ac";
export var outgoing = "styles-module--outgoing--988f7";
export var threadContainer = "styles-module--threadContainer--f023e";